<template>
  <div class="devices">
    <el-row class="device-title">
      <el-col :span="3">
        <span class="h3">设备列表</span>
      </el-col>
      <el-col :span="21" class="device-list-filter">
        <el-form label-width="72px" :inline="true" size="mini">

          <el-col :span="7">
            <el-form-item label="所属产品:">
              <el-select placeholder="请选取对应的产品" class="device-input-filter"
                         @change="loadDeviceSearch"
                         v-model="pagination.productUuid">
                <el-option v-for="item in factoryProductNames"
                           :key="item.uuid"
                           :label="item.name"
                           :value="item.uuid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="所属企业:">
              <el-select placeholder="请选取对应经销商" class="device-input-filter"
                         @change="loadDeviceSearch"
                         v-model="pagination.enterpriseUuid">
                <el-option v-for="item in deliveries"
                           :key="item.uuid"
                           :label="item.name"
                           :value="item.uuid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="设备编号:">
              <el-input placeholder="请输入设备编号" class="device-input-filter"
                        @change="loadDeviceSearch"
                        clearable
                        v-model="pagination.deviceUuid"
                        prefix-icon="el-icon-search"></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="1" class="more">
                         <span @click="handleMoreFilter">{{moreInfo}} <i class="iconfont icon-xiangshangjiantou"
                                                                         v-if="more"></i>
                                <i class="iconfont icon-xiangxiajiantou" v-else></i>
                            </span>
          </el-col>
        </el-form>
        <el-form label-width="72px" :inline="true" size="mini" v-show="more">
          <el-col :span="7">
            <el-form-item label="IMEI:">
              <el-input placeholder="请输入设备IMEI编号" class="device-input-filter"
                        @change="loadDeviceSearch"
                        v-model="pagination.iemi"
                        clearable
                        prefix-icon="el-icon-search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="地理位置:">
              <el-cascader
                class="device-input-filter"
                size="mini"
                :options="options"
                v-model="areaInfo"
                :props="{ expandTrigger: 'hover' }"
                @change="handleAreaChange">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="设备状态:">
              <el-select placeholder="请选择设备状态" class="device-input-filter"
                         @change="loadDeviceSearch"
                         v-model="pagination.deviceStatus">
                <el-option v-for="item in deviceStatusOption"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="注册时间:">
              <el-date-picker
                v-model="makeTimeRange"
                @change="loadDeviceSearch"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-form>
      </el-col>
    </el-row>
    <div class="device-data-list">
      <el-table :data="devices" stripe>
        <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid">
        </el-table-column>
        <el-table-column label="所属经销商" align="center" prop="enterpriseName"></el-table-column>
        <el-table-column label="IMEI编号" align="center" prop="deviceId"></el-table-column>
        <el-table-column label="产品" align="center" prop="productName" width="100"></el-table-column>
        <el-table-column label="设备状态" align="center">
          <template slot-scope="scope">
            <div class="device-status">
                            <span :class="[{ offline: scope.row.status ==1 }, { normal: scope.row.status ==2 },
                                    { warning: scope.row.status ==3 },
                                    { fault: scope.row.status ==4 }]">
                                   <span class="circle"></span> {{scope.row.status | filterName}}
                                </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="设备位置" align="center">
          <template slot-scope="scope">
            <div class="device-address" v-if="scope.row.province.length >0">
              <p>{{scope.row.province}}/{{scope.row.city}}</p>
              <p>{{scope.row.address}}</p>
            </div>
            <div v-else>
              <p>暂未获取信息</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" align="center">
          <template slot-scope="scope">
            <span>{{new Date(scope.row.registerAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
          <template slot-scope="scope">
            <span @click="handleDelete(scope.row, scope.$index)" class="device-edit">重置设备</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
  </div>

</template>

<script>
  import {provinceAndCityDataPlus, CodeToText} from 'element-china-area-data'
  import {deviceUnion, deviceList} from '@/api/factory/device/device'
  import {enterpriseAllName} from '@/api/factory/account/enterprise'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: '',
    components: {},
    computed: {
      ...mapGetters(['factoryProductNames'])
    },
    mounted: function () {
      this.loadDevice()
      this.loadProductNames()
      this.loadEnterprise()
    },
    data: function () {
      return {
        options: provinceAndCityDataPlus,
        deliveries: [],
        pickerOptions: {
          shortcuts: [{
            text: this.$t('jin_tian'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0, 0, 0, 0)
              end.setHours(23, 59, 59, 0)
              picker.$emit('pick', [start, end]);
            }
          }, {
             text: this.$t('zuo_tian'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              start.setHours(0, 0, 0, 0)
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              end.setHours(23, 59, 59, 0)

              picker.$emit('pick', [start, end]);
            }
          }, {
             text: this.$t('zui_jin_yi_zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
             text: this.$t('zui_jin_yi_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
             text: this.$t('zui_jin_san_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        makeTimeRange: [],
        more: false,
        moreInfo: '更多',
        devices: [],
        areaInfo: [],
        deviceStatusOption: [
          {label: '所有设备', value: 0},
          {label: '离线', value: 1},
          {label: '在线运行', value: 2},
          {label: '待维护', value: 3},
          {label: '待维修', value: 4},
        ],
        pagination: {
          productUuid: '',
          enterpriseUuid: '',
          deviceStatus: 0,
          deviceUuid: '',
          iemi: '',
          province: '',
          city: '',
          registerStartAt: 0,
          registerEndAt: 0,
          start: 0,
          curPage: 1,
          limit: 10,
          total: 0,
        },
      }
    },
    filters: {
      filterName(status) {
        switch (status) {
          case 1:
            return '离线'
          case 2:
            return '正常运行'
          case 3:
            return '待维护'
          case 4:
            return '待维修'
        }
      },
    },
    methods: {
      ...mapActions(["loadProductNames"]),
      handleEdit(row, index) {
      },
      handleDelete(row, index) {
      },
      handleAreaChange(value) {
        this.pagination.city = ''
        if (!value[0].length) {
          this.pagination.province = ''
          this.pagination.city = ''
        } else {
          this.pagination.province = CodeToText[value[0]]
          if (value[1].length) {
            let city = CodeToText[value[1]]
            if (city !== '全部') {
              this.pagination.city = city
            }
          }
        }
        this.loadDeviceSearch()
      },
      handleMoreFilter() {
        this.moreInfo = this.more ? '更多' : '收起'
        this.more = !this.more
      },

      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        deviceList(this.pagination).then(res => {
          this.devices = res.data
        })
      },
      loadEnterprise() {
        let vue = this
        enterpriseAllName().then(res => {
          vue.deliveries = res.data || []
        })
      },
      loadDevice() {
        let vue = this
        deviceUnion(this.pagination).then(res => {
          vue.devices = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },
      loadDeviceSearch() {
        let vue = this

        if (vue.makeTimeRange.length) {
          vue.pagination.registerStartAt = vue.makeTimeRange[0].getTime() / 1000
          vue.pagination.registerEndAt = vue.makeTimeRange[1].getTime() / 1000
        }
        this.pagination.curPage = 1
        this.pagination.start = 0
        deviceUnion(this.pagination).then(res => {
          vue.devices = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },
    },
  }
</script>

<style lang="scss">
  .devices {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .device-title {
      .device-input-filter {
        input {
          border: none;
          border-bottom: 1px solid $f_fiv_color;
          font-size: $filter-font-size;
          border-radius: 0;
        }
      }

      .device-status-filter {
        max-width: 124px;

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .more {
        font-size: .6rem;
        height: 28px !important;
        line-height: 28px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        span {
          cursor: pointer;
        }
      }
    }

    .device-data-list {
      margin-top: $padding;
      flex: 1;

      .device-status {
        .device-info-img {
        }

        .device-info-detail {

          p {
            margin-bottom: $padding-5;
          }

          p:first-child {
            font-size: .8rem;
          }
        }
      }

      .device-address {
        p {
          margin-bottom: $padding-5;
        }
      }

      .el-table {
        thead {
          tr {
            th {
              border-bottom: 1px solid $border_sec_color;
            }
          }
        }

      }

      .el-table--striped .el-table__body tr.el-table__row--striped td {
        background-color: #252931;
      }

      .el-table--group::after, .el-table--border::after, .el-table::before {
        background-color: transparent;
      }

      .el-table__row:hover {
        background-color: $bg_sec_color;
      }

      .device-edit, .device-delete {
        cursor: pointer;
        display: inline-block;
        margin-right: $padding;
      }

      .device-edit:hover, .device-delete:hover {
        color: $f_color;
      }

      .device-edit {
        color: $btn_color;
      }

      .device-delete {
        color: $btn_sec_color;
      }

      .circle {
        border-radius: $small_font_size;
        width: $small_font_size;
        height: $small_font_size;
        display: inline-block;
        margin-right: 5px;
      }

      .offline {
        color: #5B8FF9;

        .circle {
          background-color: #5B8FF9;
        }
      }

      .normal {
        color: #5AD8A6;

        .circle {
          background-color: #5AD8A6;
        }
      }

      .warning {
        color: #F6BD16;

        .circle {
          background-color: #F6BD16;
        }
      }

      .fault {
        color: #E8684A;

        .circle {
          background-color: #E8684A;
        }
      }

    }

    .pagination {
      margin: $padding;
    }
  }

</style>
